import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as GC from "../../../../common/common";

export default function standart() {}

export const FillTableCallBack = (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      $.each(result.data, function (index, data) {
        var circleType = "";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var statusBudget =
          data.content["status-budget"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusDetailplanning =
          data.content["status-detailplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusGlobaleplanning =
          data.content["status-globaleplanning"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';

        var statusVerzonden =
          data.content["status-verzonden"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusWerkorder =
          data.content["status-werkorder"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusWerkplan =
          data.content["status-werkplan"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var statusUitvoering =
          data.content["status-uitvoering"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var planningIscorrectiefonderhoud =
          data.content["planning-iscorrectiefonderhoud"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        /**iconların bitişi */

        /**diğer alanların başlangıcı */
        var algemeenGisratio = data.content["algemeen-gisratio"];
        if (typeof algemeenGisratio === "undefined") {
          algemeenGisratio = "";
        }
        var maatregelNaam = data.content["maatregel-naam"];
        if (typeof maatregelNaam === "undefined") {
          maatregelNaam = "";
        }
        var planningGlobalePlanning = data.content["planning-globaleplanning"];
        if (typeof planningGlobalePlanning === "undefined") {
          planningGlobalePlanning = "";
        } else {
          planningGlobalePlanning =
            GC.FormatDate(planningGlobalePlanning[0], "date") +
            " - " +
            GC.FormatDate(planningGlobalePlanning[1], "date");
        }
        var planningDetailPlanning = data.content["planning-detailplanning"];
        if (typeof planningDetailPlanning === "undefined") {
          planningDetailPlanning = "";
        } else {
          planningDetailPlanning =
            GC.FormatDate(planningDetailPlanning[0], "date") +
            " - " +
            GC.FormatDate(planningDetailPlanning[1], "date");
        }
        var status = data.status[0].status;
        if (typeof status === "undefined") {
          status = "";
        }
        var disciplineNaam = data.content["discipline-naam"];
        if (typeof disciplineNaam === "undefined") {
          disciplineNaam = "";
        }
        var werkplanNaam = data.content["werkplan-naam"];
        if (typeof werkplanNaam === "undefined") {
          werkplanNaam = "";
        }

        var planningsPeriodeStartdatum =
          data.content["planningsperiode-startdatum"];
        if (typeof planningsPeriodeStartdatum === "undefined") {
          planningsPeriodeStartdatum = "";
        } else planningsPeriodeStartdatum = GC.FormatDate(planningsPeriodeStartdatum, "date");

        var statusTijdstipVerzonden = data.content["status-tijdstip_verzonden"];
        if (typeof statusTijdstipVerzonden === "undefined") {
          statusTijdstipVerzonden = "";
        } else statusTijdstipVerzonden = GC.FormatDate(statusTijdstipVerzonden, "date");

        var model = {
          statusBudget: statusBudget,
          statusDetailplanning: statusDetailplanning,
          statusGlobaleplanning: statusGlobaleplanning,
          statusVerzonden: statusVerzonden,
          statusWerkorder: statusWerkorder,
          algemeenGisratio: algemeenGisratio,
          maatregelNaam: maatregelNaam,
          planningGlobalePlanning: planningGlobalePlanning,
          planningDetailPlanning: planningDetailPlanning,
          status: status,
          disciplineNaam: disciplineNaam,
          werkplanNaam: werkplanNaam,
          planningsPeriodeStartdatum: planningsPeriodeStartdatum,
          statusTijdstipVerzonden: statusTijdstipVerzonden,
          identification: data.identification,
        };
        window.$mm_performance_Glist.push(model);

        var test = {
          checkbox: checkbox,
          active: circleType,
          status_detailplanning: statusDetailplanning,
          status_budget: statusBudget,
          status_uitvoering: statusUitvoering,
          status_werkplan: statusWerkplan,
          planning_iscorrectiefonderhoud: planningIscorrectiefonderhoud,
          status_verzonden: statusVerzonden,
          "Gisratio Id": algemeenGisratio,
          "Naam maatregel": maatregelNaam,
          "Globale planning": planningGlobalePlanning,
          "Detail planning": planningDetailPlanning,
          Status: status,
          "Naam discipline": disciplineNaam,
          "Naam werkplan": werkplanNaam,
          "Startdatum Planningsperiode": planningsPeriodeStartdatum,
          "Tijdstip verzonden": statusTijdstipVerzonden,
        };

        var _columnList = [];
        for (let column in columnList.column_list) {
          for (let key in test) {
            if (
              columnList.column_list[column].toLowerCase() == key.toLowerCase()
            ) {
              _columnList.push(test[key]);
            }
          }
        }
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // statusDetailplanning,
            // statusBudget,
            // statusUitvoering,
            // statusWerkplan,
            // planningIscorrectiefonderhoud,
            // statusVerzonden,
            // algemeenGisratio,
            // maatregelNaam,
            // planningGlobalePlanning,
            // planningDetailPlanning,
            // status,
            // disciplineNaam,
            // werkplanNaam,
            // planningsPeriodeStartdatum,
            // statusTijdstipVerzonden,
          ],
          false
        );

        var theNode = $("#example").dataTable().fnSettings().aoData[
          addId[0]
        ].nTr;
        theNode.setAttribute("rowId", data["identification"]);
      });
      oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }

  $("#total-rows").html(result.meta.total_found);
  window.$mm_performance_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$mm_performance_treeChangeStatus = true;
  window.$mm_performance_gvv = 0;
  window.$mm_performance_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-gisratio") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_performanceAlgemeenGisratio.push(data);
    });
  } else if (data.id === "maatregel-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_maatregelNaam.push(data);
    });
  } else if (data.id === "planning-globaleplanning") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_planning_globaleplanning.push(data);
    });
  } else if (data.id === "planning-detailplanning") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_planning_detailplanning.push(data);
    });
  } else if (data.id === "status") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_performanceStatus.push(data);
    });
  } else if (data.id === "discipline-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_disciplineNaam.push(data);
    });
  } else if (data.id === "werkplan-naam") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_werkplanNaam.push(data);
    });
  } else if (data.id === "planningsperiode-startdatum") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_planningsPeriodeStartdatum.push(data);
    });
  } else if (data.id === "status-tijdstip_verzonden") {
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_statusTijdstipVerzonden.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-gisratio") {
    window.$mm_performance_performanceAlgemeenGisratio.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_performanceAlgemeenGisratio.push(data);
    });
  } else if (searchId === "maatregel-naam") {
    window.$mm_performance_maatregelNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_maatregelNaam.push(data);
    });
  } else if (searchId === "planning-globaleplanning") {
    window.$mm_performance_planning_globaleplanning.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_planning_globaleplanning.push(data);
    });
  } else if (searchId === "planning-detailplanning") {
    window.$mm_performance_planning_detailplanning.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_planning_detailplanning.push(data);
    });
  } else if (searchId === "status") {
    window.$mm_performance_performanceStatus = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_performanceStatus.push(data);
    });
  } else if (searchId === "discipline-naam") {
    window.$mm_performance_disciplineNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_disciplineNaam.push(data);
    });
  } else if (searchId === "werkplan-naam") {
    window.$mm_performance_werkplanNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_werkplanNaam.push(data);
    });
  } else if (searchId === "planningsperiode-startdatum") {
    window.$mm_performance_planningsPeriodeStartdatum.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_planningsPeriodeStartdatum.push(data);
    });
  } else if (searchId === "status-tijdstip_verzonden") {
    window.$mm_performance_statusTijdstipVerzonden.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$mm_performance_statusTijdstipVerzonden.push(data);
    });
  }
};

export const beheereenheidSavedCallBack = (token) => {
  Common.sleep(800).then(() => {
    var model = {
      action: "ADD",
      contextRol: "Beheereenheid zit in folder",
      folder: document.getElementById("tree-parent-id").value,
    };
    Common.StartActivity(
      model,
      window.$catalog_management_units_newInsertId,
      "708371ee-e3f6-4de7-87f8-dfe94b86f9b1",
      beheereenheidSavedNext(token),
      token
    );
  });
};
function beheereenheidSavedNext(token) {
  Common.sleep(4000).then(() => {
    $("#beheereenheid_toevoegen_modal").modal("hide");
    window.$mm_performance_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

export const BeheereenheidEditCallBack = (token) => {
  Common.sleep(800).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    window.$mm_performance_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const RowsDeletedCallBack = (token) => {
  Common.sleep(500).then(() => {
    $("#management-units-mappen_beheren_delete_modal").modal("hide");
    window.$mm_performance_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_management_units_lastUsedTableFilter,
        1,
        token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetActionsOfRowCallback = (result) => {
  var actionsOfSelection = [];
  var actionsOfDisabled = [];

  $.each(result.data.stages, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });

  $("#myPopup").html("");
  $.each(window.$mm_performance_actions, function (index, action) {
    if ($.inArray(action["id"], actionsOfSelection) !== -1) {
      var anchor = $("<a></a>")
        .attr({ href: "javascript:void(0)", id: action["id"] })
        .addClass(action["class"] + " mm_performance_action")
        .html(action["text"]);
      $("#myPopup").append(anchor);
    }
  });
  //** aktif olmayan actionlar burada listeleniyor. */
  // $.each(actionsOfDisabled, function (index, action) {
  //   var anchor = $("<a disabled></a>")
  //     .attr({ href: "javascript:void(0)", id: action["identification"] })
  //     .addClass("disabled" + " catalog-action")
  //     .html(action["name"]);
  //   $("#myPopup").append(anchor);
  // });
  // var beheereenheidToevoegen = $("<a></a>")
  //   .attr({ href: "javascript:void(0)", id: "beheereenheid_toevoegen" })
  //   .addClass("locate beheereenheid")
  //   .html("Beheereenheid toevoegen");
  // $("#myPopup").append(beheereenheidToevoegen);

  const showOnMap = $("<a></a>")
      .attr({ role: "button", id: "pe_toon_dossiers_op_kaart" })
      .addClass("locate action")
      .html("Toon op kaart");
  $("#myPopup").append(showOnMap);

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const WijzigStatusCallback = (result, elementId) => {
  $("#" + elementId).html("");
  $.each(
    result.data.input_data_definition.structure_definition.schema.properties
      .status.enum,
    function (index, row) {
      var btn = '<div class="custom-control custom-radio">';
      btn +=
        '<input type="radio" class="custom-control-input" name="wijzig-status"  id="' +
        row +
        '" value="' +
        row +
        '" />';
      btn +=
        '<label class="custom-control-label" for="' +
        row +
        '">' +
        row +
        "</label></div>";
      $("#" + elementId).append(btn);
    }
  );
};

export const UitvoerderCallback = (result) => {
  $("#uitvoerder-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="uitvoerder"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#uitvoerder-grp").append(btn);
  });
};

export const BudgetCallback = (result) => {
  $("#budget-grp").html("");
  $.each(result.data, function (index, row) {
    var btn = '<div class="custom-control custom-radio">';
    btn +=
      '<input type="radio" class="custom-control-input" name="budget"  id="' +
      row["identification"] +
      '" value="' +
      row["identification"] +
      '" />';
    btn +=
      '<label class="custom-control-label" for="' +
      row["identification"] +
      '">' +
      row["name"] +
      "</label></div>";
    $("#budget-grp").append(btn);
  });
};

export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    if (index < 20) {
      test_list.push(element.sTitle);
    }
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";

  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";

  var status_detailplanningIndex = test_list.findIndex((x) =>
    x.includes("status_detailplanning")
  );
  test_list[status_detailplanningIndex] = "status_detailplanning";
  var status_budgetIndex = test_list.findIndex((x) =>
    x.includes("status_budget")
  );
  test_list[status_budgetIndex] = "status_budget";
  var status_uitvoeringIndex = test_list.findIndex((x) =>
    x.includes("status_uitvoering")
  );
  test_list[status_uitvoeringIndex] = "status_uitvoering";
  var status_werkplanIndex = test_list.findIndex((x) =>
    x.includes("status_werkplan")
  );
  test_list[status_werkplanIndex] = "status_werkplan";
  var planning_iscorrectiefonderhoudIndex = test_list.findIndex((x) =>
    x.includes("planning_iscorrectiefonderhoud")
  );
  test_list[planning_iscorrectiefonderhoudIndex] =
    "planning_iscorrectiefonderhoud";
  var status_verzondenIndex = test_list.findIndex((x) =>
    x.includes("status_verzonden")
  );
  test_list[status_verzondenIndex] = "status_verzonden";

  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "management-maintenance>performance",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "management-maintenance>performance"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
